<template>
    <div id="hero" class="" :ref="stepName">
        <div class="text-box max-width">
            <b-button class="button is-primary next-button" @click="nextStep()" style="max-width: 265px">Demandez votre pack  </b-button>
        </div>
        <b-loading :is-full-page="false" v-model="loading"></b-loading>
    </div>
</template>

<script>
import {gsap} from 'gsap';
import mixin from "../../../travel_step_mixin";
import ScrollLink from "../../../../../../views/_commons/fr/ScrollLink";
import animation_mixin from "../../../animation_engine_mixin";

export default {
    mixins: [mixin],
    components:{ScrollLink},
    mounted(){

    }
}
</script>

<style lang="scss" scoped>
.max-width{
    max-width: 30%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transform: translateY(-110px);
    @media (max-width: 768px) {
        display: none;
    }
}
</style>
